/**
 * Reading what a form actually holds.
 *
 * Every field in the app is a controlled React input, which is fine until
 * something other than a keystroke fills one. A password manager, iOS
 * autofill and a page restored by the back button all set the value on the
 * element itself, and React never hears about it: its state stays empty
 * while the box on screen is full.
 *
 * Sign-in is where that bites. An empty email passes the browser's own
 * `required` check, because the element does have a value, and reaches
 * Cognito as `USERNAME: ""`, which answers "Missing required parameter
 * USERNAME" — a message about a parameter, pointed at somebody looking
 * straight at their own address in the box.
 *
 * So a form that must not submit the wrong thing reads its fields here
 * instead of trusting state.
 */

/** What the named field holds, or `fallback` when the form has no answer. */
export function fieldValue(form: HTMLFormElement, name: string, fallback: string): string {
  const field = form.elements.namedItem(name);
  const value =
    field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement ? field.value : "";
  return value === "" ? fallback : value;
}
